<div class="modal-header d-flex align-items-center justify-content-center">
  <h4 class="modal-title ps-2">{{ 'loggedOutDueToInactivityTitle' | translate }}</h4>
</div>
<div class="modal-body d-flex flex-column justify-content-center align-items-center">
  <div class="c-mtm-black modal-description mb-3">{{ logoutMessageKey | translate }}</div>
  <button class="btn b-mtm-brand c-full-white _600" (click)="close()">{{ 'close' | translate }}</button>
</div>
